type BrandLineProps = {
  brandName?: string;
};

/**
 * Extra line with the product brand, meant to be shown below a product code or
 * name in a table cell. Renders nothing when the product has no brand.
 */
const BrandLine: React.FC<BrandLineProps> = ({ brandName }) => {
  if (!brandName) {
    return <></>;
  }
  return (
    <div>
      <small className="text-muted">{brandName}</small>
    </div>
  );
};

export default BrandLine;
